/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unknown-property */
import { motion } from 'framer-motion';

export default function Blogsection() {
  const blogs = [
    {
      id: 1,
      date: "Feb 20, 2024",
      title: 'What "Mahakal Social Welfare Society" Can Do For You?',
      description: "Discover the vast range of support services we offer, from immediate relief to long-term community development strategies.",
      image: "https://ik.imagekit.io/hickter/Hickter_Projects/MSWS/Blog/1.png?updatedAt=1708333431310",
      link: "/Blog1",
      category: "Support"
    },
    {
      id: 2,
      date: "Feb 20, 2024",
      title: 'Choosing the Right Path for a Better Life',
      description: "Why our expertise and dedicated social workers make us the preferred choice for holistic social welfare and personal growth.",
      image: "https://ik.imagekit.io/hickter/Hickter_Projects/MSWS/Blog/2.png?updatedAt=1708333441056",
      link: "/Blog2",
      category: "Vision"
    },
    {
      id: 3,
      date: "Feb 12, 2024",
      title: "Education: The Backbone of Social Welfare",
      description: "Exploring how educational support creates a ripple effect of empowerment within distressed communities.",
      image: "https://ik.imagekit.io/hickter/Hickter_Projects/MSWS/Blog/3.png?updatedAt=1708333441141",
      link: "/Blog3",
      category: "Education"
    }
  ];

  return (
    <section className="w-full bg-[#fffcf9] py-20 lg:py-28 overflow-hidden">
      <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-12">
        
        {/* Header Section */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row md:items-end justify-between mb-20 gap-8"
        >
          <div className="max-w-3xl">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-12 h-[2px] bg-orange-500"></span>
              <h2 className="text-orange-600 font-bold uppercase tracking-[0.2em] text-xs">Our Journal</h2>
            </div>
            <h1 className="text-5xl md:text-7xl font-black text-gray-900 leading-[1.1]">
              Stories of <span className="text-orange-500">Hope</span> & <br/> 
              Community <span className="italic font-serif text-orange-400">Impact.</span>
            </h1>
          </div>

          <motion.a 
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            href="/Blog" 
            className="inline-flex items-center gap-3 px-8 py-4 bg-orange-500 text-white rounded-full font-bold shadow-lg shadow-orange-200 hover:bg-orange-600 transition-all group"
          >
            Explore All News
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 transition-transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </motion.a>
        </motion.div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 xl:gap-16">
          {blogs.map((blog, index) => (
            <motion.div
              key={blog.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: index * 0.15 }}
              className="group"
            >
              {/* Image Container with Orange Overlay */}
              <div className="relative h-[400px] overflow-hidden rounded-[2.5rem] mb-8 shadow-2xl shadow-orange-100">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-orange-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                {/* Category Badge */}
                <div className="absolute top-6 left-6 bg-orange-500 text-white px-5 py-1.5 rounded-full text-xs font-bold tracking-wider uppercase shadow-lg">
                  {blog.category}
                </div>
              </div>

              {/* Text Area */}
              <div className="px-2">
                <div className="flex items-center gap-4 mb-4">
                  <time className="text-orange-600 font-bold text-sm">{blog.date}</time>
                  <span className="w-1.5 h-1.5 bg-orange-200 rounded-full"></span>
                  <span className="text-gray-400 text-sm font-medium uppercase tracking-widest">Article</span>
                </div>
                
                <h3 className="text-2xl lg:text-3xl font-extrabold text-gray-900 mb-4 group-hover:text-orange-500 transition-colors duration-300 leading-tight">
                  <a href={blog.link}>{blog.title}</a>
                </h3>
                
                <p className="text-gray-500 leading-relaxed mb-8 line-clamp-2 text-lg">
                  {blog.description}
                </p>

                <a 
                  href={blog.link} 
                  className="relative inline-flex items-center gap-2 font-black text-gray-900 group-hover:text-orange-600 transition-all overflow-hidden"
                >
                  <span className="relative z-10">CONTINUE READING</span>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 relative z-10 transition-transform group-hover:translate-x-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                  <div className="absolute bottom-0 left-0 w-0 h-[2px] bg-orange-500 transition-all duration-300 group-hover:w-full"></div>
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}